import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Clock = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    defaultColorDarkMode: 'primary/text',
    defaultColorLightMode: 'primary/text',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 32 32'
    >
      <path
        fill={primaryColorToUse}
        fillRule='evenodd'
        d='M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4M1.333 16C1.333 7.9 7.9 1.333 16 1.333S30.667 7.9 30.667 16 24.1 30.667 16 30.667 1.333 24.1 1.333 16M16 6.667c.736 0 1.333.597 1.333 1.333v7.176l4.597 2.298a1.333 1.333 0 0 1-1.193 2.385l-5.333-2.667A1.33 1.33 0 0 1 14.667 16V8c0-.736.597-1.333 1.333-1.333'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default Clock;
